import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
} from "@material-ui/core";

import useModal from "../../../common/hooks/modals";

const SendInformationButton = ({
  payments,
  soldLoans,
  sellLoansBulk,
  clearDialogData,
}) => {
  const [isOpen, handleClick, handleClose] = useModal();
  const [length, setLength] = useState(1);
  const { paymentsSent } = soldLoans;

  const percentSent = (paymentsSent.length / length) * 100;

  function buttonclick() {
    handleClick();
    setLength(payments.length);
    sellLoansBulk(payments);
  }

  function clearDialog() {
    handleClose();
    clearDialogData();
  }

  return (
    <React.Fragment>
      <Button
        component="label"
        variant="outlined"
        fullWidth={false}
        style={{ width: "30%" }}
        onClick={buttonclick}
      >
        Send information
      </Button>
      <Dialog open={isOpen}>
        <DialogTitle>Sending</DialogTitle>
        <DialogContent>
          <div>
            Loans sent: {paymentsSent.length} of {length}
          </div>
          <LinearProgress
            variant="buffer"
            value={percentSent}
            valueBuffer={percentSent + length * 0.05}
          />
        </DialogContent>
        <DialogActions>
          {payments.length === paymentsSent.length ? (
            <Button variant="contained" color="primary" onClick={clearDialog}>
              Close
            </Button>
          ) : undefined}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default SendInformationButton;
